import {
  Avatar,
  Box,
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  MenuItem,
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import HandshakeIcon from "@mui/icons-material/Handshake";
import LocalFireDepartmentIcon from "@mui/icons-material/LocalFireDepartment";
import CopyrightIcon from "@mui/icons-material/Copyright";
import {
  getAllDomainRelations,
  setupDomainRelation,
} from "../../../api/specialization/SocialSpecializationAPI";
import { OptionsObject, useSnackbar } from "notistack";
import { AlertSuccessProp } from "../../../components/SnackbarNoti";
import RandomColor from "../../../util/RandomColor";
import TrendzContainerCard from "../../../components/TrendzContainerCard";

export function SettingDomainPage() {
  const { t } = useTranslation(["common", "social", "keyword"]);
  const [domains, setDomains] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [inputDomain, setInputDomain] = useState("");
  const [domainType, setDomainType] = useState("OWNER");
  const { enqueueSnackbar } = useSnackbar();
  const [reloadCondition, setReloadCondition] = useState(false);
  useEffect(() => {
    getAllDomainRelations().then((res) => {
      setDomains(res);
    });
  }, [reloadCondition]);

  var rows = domains.map((domain) => {
    var chip = (
      <Chip color={"info"} label={t("social:" + domain["relationType"])}></Chip>
    );
    if (domain["relationType"] == "OPPONENT") {
      var chip = (
        <Chip
          color={"error"}
          label={t("social:" + domain["relationType"])}
        ></Chip>
      );
    }
    if (domain["relationType"] == "PARTNER") {
      var chip = (
        <Chip
          color={"success"}
          label={t("social:" + domain["relationType"])}
        ></Chip>
      );
    }

    return (
      <TableRow
        key={domain["id"]}
        style={{
          backgroundColor: RandomColor({ name: domain["relationType"] }),
        }}
      >
        <TableCell
          style={{
            paddingTop: "0px",
            paddingBottom: "0px",
          }}
        >
          <Avatar
            alt={domain["domain"]}
            src={
              "https://www.google.com/s2/favicons?domain=" +
              domain["domain"] +
              "/favicon.ico"
            }
            sx={{
              width: "20px",
              height: "20px",
            }}
          />
        </TableCell>
        <TableCell
          style={{
            paddingTop: "0px",
            paddingBottom: "0px",
          }}
          sx={{ fontWeight: "500 !important", flexDirection: "row" }}
        >
          {domain["domain"] ? domain["domain"] : t("common:unknown")}
        </TableCell>
        <TableCell style={{ paddingTop: "0px", paddingBottom: "0px" }}>
          {chip}
        </TableCell>
        <TableCell style={{ paddingTop: "0px", paddingBottom: "0px" }}>
          <Tooltip title={t("social:label_this_domain_as_yours")}>
            <IconButton
              onClick={(e) => {
                e.preventDefault();
                setupDomainRelation(domain["domain"], "OWNER").then((res) => {
                  enqueueSnackbar(
                    t("common:update_successfully"),
                    AlertSuccessProp as OptionsObject
                  );
                  setReloadCondition(!reloadCondition);
                });
              }}
              color="info"
            >
              <CopyrightIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title={t("social:label_this_domain_as_partner")}>
            <IconButton
              onClick={(e) => {
                e.preventDefault();
                setupDomainRelation(domain["domain"], "PARTNER").then((res) => {
                  enqueueSnackbar(
                    t("common:update_successfully"),
                    AlertSuccessProp as OptionsObject
                  );
                  setReloadCondition(!reloadCondition);
                });
              }}
              color="success"
            >
              <HandshakeIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title={t("social:label_this_domain_as_opponent")}>
            <IconButton
              onClick={(e) => {
                e.preventDefault();
                setupDomainRelation(domain["domain"], "OPPONENT").then(
                  (res) => {
                    enqueueSnackbar(
                      t("common:update_successfully"),
                      AlertSuccessProp as OptionsObject
                    );
                    setReloadCondition(!reloadCondition);
                  }
                );
              }}
              color="error"
            >
              <LocalFireDepartmentIcon />
            </IconButton>
          </Tooltip>
        </TableCell>
      </TableRow>
    );
  });
  return (
    <TrendzContainerCard title={t("social:manage_domains")}>
      <Grid item xs={0.75}></Grid>
      <Grid item xs={10.5}>
        <Grid item xs={6}>
          <Dialog
            open={openDialog}
            onClose={() => {
              setOpenDialog(false);
            }}
            maxWidth="md"
            fullWidth
          >
            <DialogTitle>{t("social:manage_domains")}</DialogTitle>
            <DialogContent>
              <TextField
                margin="dense"
                id="name"
                label={t("social:domain")}
                placeholder={t("social:type_domain_here").toString()}
                fullWidth
                required
                variant="standard"
                onChange={(e) => {
                  setInputDomain((e.target as HTMLInputElement).value);
                }}
              ></TextField>
              <Select
                value={domainType}
                onChange={(e) => {
                  setDomainType(e.target.value as string);
                }}
                label={t("social:domain_relation_type")}
                placeholder={t("social:domain_relation_type")}
              >
                <MenuItem value="OWNER">{t("social:OWNER")}</MenuItem>
                <MenuItem value="PARTNER">{t("social:PARTNER")}</MenuItem>
                <MenuItem value="OPPONENT">{t("social:OPPONENT")}</MenuItem>
              </Select>
              <DialogActions sx={{ marginTop: "20px" }}>
                <Button
                  variant="contained"
                  onClick={() => {
                    setupDomainRelation(inputDomain, domainType).then((res) => {
                      setOpenDialog(false);
                      setReloadCondition(!reloadCondition);
                    });
                    setOpenDialog(false);
                  }}
                >
                  Submit
                </Button>
              </DialogActions>
            </DialogContent>
          </Dialog>
          <Box
            display={"flex"}
            justifyContent={"flex-begin"}
            marginBottom={"20px"}
          >
            <Button
              variant="contained"
              color="success"
              style={{ width: "120px", marginRight: "30px" }}
              onClick={() => setOpenDialog(true)}
            >
              {t("common:create")}
            </Button>{" "}
          </Box>
          <TableContainer component={Paper}>
            <Table>
              <colgroup>
                <col style={{ width: "5%" }} />
                <col style={{ width: "35%" }} />
                <col style={{ width: "30%" }} />
                <col style={{ width: "20%" }} />
              </colgroup>
              <TableHead>
                <TableRow>
                  <TableCell></TableCell>
                  <TableCell sx={{ fontWeight: "600 !important" }}>
                    {t("social:domain")}
                  </TableCell>
                  <TableCell sx={{ fontWeight: "600 !important" }}>
                    {t("social:domain_relation_type")}
                  </TableCell>
                  <TableCell
                    sx={{
                      align: "center",
                      textAlign: "center",
                      fontWeight: "600 !important",
                    }}
                  >
                    {t("common:actions")}
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>{rows}</TableBody>
            </Table>
          </TableContainer>
        </Grid>
      </Grid>
      <Grid item xs={5}></Grid>
      <Grid item xs={0.75}></Grid>
    </TrendzContainerCard>
  );
}
